/**
 * tabsConfig — Ordine e metadati dei tab principali dell'app.
 * Estratto da App.js il 16/07/2026 per ridurre l'impronta del file
 * monolitico. La logica resta 1:1 rispetto all'originale.
 *
 * `Impostazioni` viene aggiunto solo se `isAdmin` (amministratore
 * o responsabile) — vedi App.js `operatorRole` handling.
 */

import {
  Home,
  FileText,
  BookUser,
  Receipt,
  Users,
  CalendarClock,
  BarChart3,
  FileSignature,
  Settings,
} from "lucide-react";

export function buildTabsConfig(isAdmin) {
  const base = [
    { value: "dashboard",         label: "Cruscotto",           icon: Home,           testid: null },
    { value: "cases",             label: "Gestione Pratiche",   icon: FileText,       testid: "tab-registro-pratiche" },
    { value: "attivita",          label: "Attività Operative",  icon: BookUser,       testid: null },
    { value: "fatturazione",      label: "Fatturazione",        icon: Receipt,        testid: null },
    { value: "clients",           label: "Clienti",             icon: Users,          testid: null },
    { value: "scadenze",          label: "Scadenzario",         icon: CalendarClock,  testid: null },
    { value: "report",            label: "Report",              icon: BarChart3,      testid: null },
    { value: "registro-attivita", label: "Cliente 360°",         icon: FileSignature,  testid: "tab-registro-attivita" },
    { value: "modulistica",       label: "Modulistica",         icon: FileSignature,  testid: null },
  ];
  if (isAdmin) base.push({ value: "impostazioni", label: "Impostazioni", icon: Settings, testid: null });
  return base;
}

export default buildTabsConfig;
